import get from 'lodash/get';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps, ComponentDescriptor } from 'app/infrastructure/ui/types-uischema';
import { getEntityContext, resolveDomainMetadata, matchesCurrentValidationContext,
  mapToValidationProps, 
  defaultArray} from 'app/infrastructure/ui/renderer/resolvers';
import { ValidationProps } from 'ui/common/validation/types';
import { ValidationDomainMatch } from 'app/types-shared';
import { createSelector } from 'reselect';

export const validationDescendants = createSelector(
  (state: CaseState, uiEngineProps: ConnectedComponentProps) => ({
    context: getEntityContext(state, uiEngineProps),
    domainMetadata: resolveDomainMetadata(getEntityContext(state, uiEngineProps), state, uiEngineProps),
    children: uiEngineProps.componentDescriptor.children ? uiEngineProps.componentDescriptor.children
      .concat(
        uiEngineProps.detailsViewDescriptor ?
        uiEngineProps.detailsViewDescriptor.children :
        defaultArray
      ) : defaultArray
  }),
  ({ context, domainMetadata, children }) => {
    if (!context || !domainMetadata || !children) {
      return undefined;
    }

    const childValidationErrors: ValidationProps[] = [];

    const aggregatedErrorList = (child: ComponentDescriptor) => {
      const allValidations = get(domainMetadata, `[${child.id}].validations`, []) as ValidationDomainMatch[];
      const validations = allValidations.filter(v => matchesCurrentValidationContext(context, v));
      validations.length && childValidationErrors.push(mapToValidationProps(child.id, validations));

      child.children && child.children.filter(x => x).map(aggregatedErrorList);
    };

    const onlyUniqueMessages = (v: ValidationProps, i: number, a: ValidationProps[]) => 
      i === a.findIndex(f => JSON.stringify(v.messages) === JSON.stringify(f.messages));

    children.map(aggregatedErrorList);

    return { validationDescendants: childValidationErrors.filter(onlyUniqueMessages) };
  }
);
